<template>
  <div v-if="value">
    <div v-if="showSkeleton" class="flex flex-col gap-5">
      <Skeleton type="header" />
      <Skeleton type="block" />
    </div>

    <transition name="fade">
      <div
        v-if="value"
        class="flex justify-center items-center fixed inset-0 z-50 bg-transparent backdrop-blur-sm"
      >
        <div
          class="p-12 inline-flex flex-col justify-center items-center gap-5 rounded-xl border border-border bg-card text-card-foreground shadow-sm"
        >
          <!-- Spinner -->
          <div class="w-10 h-10 flex justify-center items-center">
            <LoadingIcon v-if="isLoading" :scale="1.5" />
          </div>

          <!-- Text -->
          <div
            class="flex flex-col justify-center items-center gap-2 text-center"
          >
            <div
              class="max-w-80 text-base font-semibold leading-6 text-foreground"
            >
              {{ title }}
            </div>
            <div
              class="max-w-[280px] text-sm font-normal leading-5 text-muted-foreground"
            >
              {{ subtitle }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Skeleton from "@/shared/ui/custom/skeleton/Skeleton.vue";
import LoadingIcon from "@/shared/ui/custom/components/LoadingIcon.vue";

export default {
  name: "LoadingOverlay",
  components: { Skeleton, LoadingIcon },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    showSkeleton: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: () => "Загружаем среду",
    },
    subtitle: {
      type: String,
      default: () =>
        "Мы подготавливаем все необходимое,\n" +
        "это займет совсем немного времени",
    },
  },
  data() {
    return {
      isLoading: this.value,
    };
  },
};
</script>

<style></style>
